const SmartPhoneSvg = ({ isActive = false }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4422_18412)">
      <path
        d="M12.2857 1.5H3.71429C2.76751 1.5 2 2.1268 2 2.9V14.1C2 14.8732 2.76751 15.5 3.71429 15.5H12.2857C13.2325 15.5 14 14.8732 14 14.1V2.9C14 2.1268 13.2325 1.5 12.2857 1.5Z"
        stroke={isActive ? '#00ab6b' : '#333333'}
        strokeWidth={isActive ? '1.5' : '1'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.5H8.00667"
        stroke={isActive ? '#00ab6b' : '#333333'}
        strokeWidth={isActive ? '2' : '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4422_18412">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SmartPhoneSvg;
